import { useCallback, useRef, useState } from 'react';

export const useIsOverflown = (disabled = false) => {
    const [isOverflown, setIsOverflown] = useState(false);
    const elementRef = useRef<HTMLElement | null>(null);
    const observerRef = useRef<ResizeObserver | null>(null);

    const refFn = useCallback(
        (node: HTMLElement | null) => {
            const cleanup = () => {
                setIsOverflown(false);
                observerRef.current?.disconnect();
                observerRef.current = null;
                elementRef.current = null;
            };

            if (disabled || !node) {
                cleanup();
                return;
            }

            if (node === elementRef.current) {
                return;
            }

            cleanup();
            elementRef.current = node;

            const checkOverflow = () => {
                setIsOverflown(node.scrollWidth > node.clientWidth);
            };

            checkOverflow();

            observerRef.current = new ResizeObserver(() => checkOverflow());
            observerRef.current.observe(node);
        },
        [disabled]
    );

    return [refFn, isOverflown] as const;
};
